/* merchant/actions */
import { action } from "typesafe-actions";
import { MerchantStaging, MerchantStagingActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(MerchantStagingActionTypes.FETCH, { id, params, callback });

export const fetchAllRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(MerchantStagingActionTypes.FETCH_ALL, { id, params, callback });

export const fetchSuccess = (data: MerchantStaging) =>
  action(MerchantStagingActionTypes.FETCH_SUCCESS, data);

export const fetchAllSuccess = (data: MerchantStaging) =>
  action(MerchantStagingActionTypes.FETCHALL_SUCCESS, data);

export const fetchError = (error: string) =>
  action(MerchantStagingActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: MerchantStaging | null) => unknown
) => action(MerchantStagingActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: MerchantStaging) =>
  action(MerchantStagingActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(MerchantStagingActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(MerchantStagingActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(MerchantStagingActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(MerchantStagingActionTypes.DELETE_ERROR, error);

export const updateState = (data: Data[]) =>
  action(MerchantStagingActionTypes.UPDATE_STATE, data);


export const downloadRequest = (
  params: { },
  callback?: (err?: string | null, data?: any | null) => unknown
) => action(MerchantStagingActionTypes.DOWNLOAD_REQUEST, { params, callback });
